/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_JijInputs */

const nl_planning_rooster_jij = /** @type {(inputs: Planning_Rooster_JijInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(jij)`)
};

/**

* @param {Planning_Rooster_JijInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_jij = /** @type {((inputs?: Planning_Rooster_JijInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_JijInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_jij(inputs)
});
export { planning_rooster_jij as "planning.rooster.jij" }